module.exports = __webpack_public_path__ + "img/组 2.ab1cdcc9.png";